export const buildGreetingGenerationPrompt = (agentName: string) => `
You are writing a welcome greeting for an AI agent named "${agentName}".

Generate exactly one polished greeting message for the agent widget.

Requirements:
- Keep it concise, natural, and friendly.
- Use first person from the agent's perspective.
- Mention the agent name only if it feels natural.
- Focus on welcoming the user and inviting them to ask for help.
- Do not include markdown, bullet points, titles, explanations, or multiple options.
- Return only the final greeting text.
`.trim();
